function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
const SvgMessenger = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  className: props.className || ''
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || 'currentColor',
  d: "m11.949 6.448-1.932 2.851a.994.994 0 0 1-.656.413c-.27.047-.55-.014-.77-.168L7.054 8.472a.42.42 0 0 0-.476 0L4.504 9.938c-.277.196-.64-.113-.453-.386L5.983 6.7a.993.993 0 0 1 .656-.413c.27-.046.55.014.77.168l1.537 1.072a.42.42 0 0 0 .476 0l2.075-1.465c.276-.197.638.112.452.386Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.706 2.007c-1 .05-1.972.346-2.828.863A5.977 5.977 0 0 0 2.81 4.968a5.918 5.918 0 0 0-.156 5.687l-.637 3.067a.23.23 0 0 0 .167.27c.037.01.077.01.115.002l3.03-.712a6.039 6.039 0 0 0 7.402-1.668 5.906 5.906 0 0 0-.167-7.527 5.996 5.996 0 0 0-2.185-1.6 6.042 6.042 0 0 0-2.672-.48v0Z"
}));
export default SvgMessenger;